import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const headerHeight = () => {
    const mainHeader = document.querySelector( '.site-header' );
    const extraHeader = document.querySelector( '.site-extra-header' );

    return ( mainHeader ? mainHeader.offsetHeight : 0 ) + ( extraHeader ? extraHeader.offsetHeight : 0 );
};

document.addEventListener( 'DOMContentLoaded', () => {
    gsap.registerPlugin( ScrollTrigger );

    const header = document.querySelector( '.site-header-wrapper' );
    const firstSection = document.querySelector( '.entry-content > div' );

    if ( firstSection && ( firstSection.classList.contains( 'is-style-nyg-starter-dark' ) || firstSection.classList.contains( 'is-style-splitkon-beige' ) || firstSection.classList.contains( 'is-style-splitkon-darker-beige' ) ) ) {
        const classToToggle = 'is-style-' + ( firstSection.classList.contains( 'is-style-nyg-starter-dark' ) ? 'nyg-starter-dark' : firstSection.classList.contains( 'is-style-splitkon-beige' ) ? 'splitkon-beige' : 'splitkon-darker-beige' );

        gsap.to( document.body, {
            scrollTrigger: {
                trigger: firstSection,
                start: 'top 50px',
                end: `bottom-=${ headerHeight() }px top`,
                scrub: true,
                toggleClass: {
                    targets: header,
                    className: classToToggle,
                },

                // markers: true,
            },
        } );
    }
} );
